import { isValidUrl, getNotifMsg } from 'utils';

const validateAddNewWebsite = (values, locale = 'fa') => {
  const { title, url } = values;
  const errors = {};
  if (!title) {
    errors.title = getNotifMsg('ENTER_WEBSITE_TITLE', locale);
  }
  if (!url) {
    errors.url = getNotifMsg('ENTER_WEBSITE_ADDRESS', locale);
  } else if (!isValidUrl(url)) {
    errors.url = getNotifMsg('INVALID_WEBSITE_ADDRESS', locale);
  }
  return errors;
};

export default validateAddNewWebsite;
